<template>
<div class="boxMenu">
    <!-- 平台简介 -->
    <div>
        <div ref="platform" class="Rectangle " @click="boxFunc(0, $event)">
            <h1 class="developer_documataion_menu_overview ">{{$t('introductionPlatform')}}</h1>
        </div>
        <ul class="displayMenu ulHideContent"></ul>
        <span style="display:none;">{{isSideBarShow}}</span>
    </div>
    <!-- 开发流程 -->
    <div>
        <div class="Rectangle" @click="boxFunc(1, $event)">
            <h1 class="developer_documataion_menu_overview ">{{$t('developmentProcess')}}</h1>
        </div>
        <ul class="displayMenu ulHideContent">
            <li @mouseenter="mouseenterLiFunc('0')" @mouseleave="mouseleaveLiFunc()" ref="start" @click="boxFuncLi('start', $event)">
                <span class="text">{{$t('getStarted')}}</span>
                <span :style="this.$store.state.isSideBarShow === 'start' ? ' background-color: #00e0da;opacity: 1; ' : ''" :class="{borderSpanClass:isLiHoverEnter === '0'}" class="line_5"></span>
            </li> 
            <li @mouseenter="mouseenterLiFunc('1')" @mouseleave="mouseleaveLiFunc()" ref="sdk" @click="boxFuncLi('sdk', $event)">
                <span class="text">{{$t('instructionsSdk')}}</span>
                <span :style="this.$store.state.isSideBarShow === 'sdk' ? ' background-color: #00e0da;opacity: 1; ' : ''" :class="{borderSpanClass:isLiHoverEnter === '1'}" class="line_5"></span>
            </li> 
            <li @mouseenter="mouseenterLiFunc('2')" @mouseleave="mouseleaveLiFunc()" ref="motion" @click="boxFuncLi('motion', $event)">
                <span class="text">{{$t('actionListDescription')}}</span>
                <span :style="this.$store.state.isSideBarShow === 'motion' ? '  background-color: #00e0da;opacity: 1;  ' : ''" :class="{borderSpanClass:isLiHoverEnter === '2'}" class="line_5"></span>
            </li>
        </ul>
    </div>
    <!-- 现阶段不存在 -->
    <!-- 规则文档 -->
    <!-- <div>
        <div class="Rectangle" @click="boxFunc(2, $event)">
            <h1 class="developer_documataion_menu_overview ">{{$t('rulesDocument')}}</h1>
        </div>
        <ul class="displayMenu ulHideContent">
            <li @mouseenter="mouseenterLiFunc('3')" @mouseleave="mouseleaveLiFunc()"  @click="boxFuncLi('nuwa', $event)">
                <span class="text">{{$t('nuwaEnterpriseIdentification')}}</span>
                <span :style="this.$store.state.isSideBarShow === 'nuwa' ? ' border: solid 1.2px #00e0da;opacity: 1; ' : ''" :class="{borderSpanClass:isLiHoverEnter === '3'}" class="line_5"></span>
            </li> 
            <li @mouseenter="mouseenterLiFunc('4')" @mouseleave="mouseleaveLiFunc()"  @click="boxFuncLi('danny', $event)">
                <span class="text">{{$t('dannyEnterpriseIdentification')}}</span>
                <span :style="this.$store.state.isSideBarShow === 'danny' ? ' border: solid 1.2px #00e0da;opacity: 1; ' : ''" :class="{borderSpanClass:isLiHoverEnter === '4'}" class="line_5"></span>
            </li> 
        </ul>
    </div> -->
</div>
</template>
<script>
    // import config from '../config'
    export default {
        name: 'SidebarName',
        data () {
            return {
                clickFlag: null,
                isLiHoverEnter: ''
            }
        },
        computed: {
            isSideBarShow () {
                if (this.$refs.sdk === undefined) {
                    setTimeout(() => {
                        if (this.$refs.sdk !== undefined) {
                            this.footerSideBarFunc()
                            return
                        }
                    }, 10)
                } else {
                    this.footerSideBarFunc()
                }
                return this.$store.state.isSideBarShow
            }
        },
        methods: {
            footerSideBarSwitch (type) {
                let elements = document.querySelectorAll('.displayMenu')
                let liElements = document.querySelectorAll('.liClass')
                type === 0 && liElements.length > 0 && liElements[0].classList.remove('liClass')
                for (let i = 0; i < elements.length; i++) {
                    if (i === type) {
                        elements[i].classList.remove('ulHideContent')
                        elements[i].classList.add('ulShowContent')
                        this.clickFlag = i
                    } else {
                        elements[i].classList.remove('ulShowContent')
                        elements[i].classList.add('ulHideContent')
                    }
                }
            },
            footerSideBarFunc () {
                let typeArr = [0, 1, 2]
                let jumpGuide = sessionStorage.isSideBarShow
                this.jumpGuide(jumpGuide)
                switch (jumpGuide) {
                    case 'sdk':
                        this.footerSideBarSwitch(typeArr[1])
                        let sdkEvent = this.$refs.sdk
                        this.boxLiClass(sdkEvent)
                        break
                    case 'motion':
                        this.footerSideBarSwitch(typeArr[1])
                        let motionEvent = this.$refs.motion
                        this.boxLiClass(motionEvent)
                        break
                    case 'start':
                        this.footerSideBarSwitch(typeArr[1])
                        let startEvent = this.$refs.start
                        this.boxLiClass(startEvent)
                        break
                    case '0':
                    case undefined:
                        this.footerSideBarSwitch(typeArr[0])
                        let platformEvent = this.$refs.platform
                        this.boxALLclass(platformEvent)
                        break
                    default:
                }
            },
            jumpGuide (jumpType) {
                switch (jumpType) {
                    case 0:
                    case '0':
                        this.$router.push({name: 'listApp'})
                        this.$store.state.isSideBarShow = jumpType
                        sessionStorage.isSideBarShow = jumpType
                        break
                    case 'sdk':
                        this.$store.state.isSideBarShow = jumpType
                        sessionStorage.isSideBarShow = jumpType
                        this.$router.push({name: 'sdkDescription', params: {sdkName: 'robotSdk'}})
                        break
                    case 'motion':
                        this.$store.state.isSideBarShow = jumpType
                        sessionStorage.isSideBarShow = jumpType
                        this.$router.push({name: 'listMotionFile'})
                        break
                    case 'start':
                        this.$store.state.isSideBarShow = jumpType
                        sessionStorage.isSideBarShow = jumpType
                        break
                    default:
                }
            },
            boxALLclass (event) {
                let ulElements = document.querySelectorAll('.ulClass')
                ulElements.length > 0 && ulElements[0].classList.remove('ulClass')
                event.classList.add('ulClass')
            },
            liClassFunc (event) {
                let ulElements = document.querySelectorAll('.ulShowContent')
                if (ulElements.length === 0) {
                    return
                }
                for (let i = 0; i < ulElements[0].children.length; i++) {
                    ulElements[0].children[i].classList.contains('liClass') && event.classList.remove('ulClass')
                }
            },
            boxLiClass (event) {
                let liElements = document.querySelectorAll('.liClass')
                let ulElements = document.querySelectorAll('.ulClass')
                // 如果是li 就将div 的class拿掉
                ulElements.length > 0 && ulElements[0].classList.remove('ulClass')
                liElements.length > 0 && liElements[0].classList.remove('liClass')
                event.classList.add('liClass')
            },
            boxFuncLi (type, event) {
                let e = event.currentTarget
                this.boxLiClass(e)
                this.jumpGuide(type)
            },
            styleGuide (type) {
                let elements = document.querySelectorAll('.displayMenu')
                if (this.clickFlag === type) {
                    if (elements[type].classList.contains('ulHideContent') === true) {
                        elements[type].classList.add('ulShowContent')
                        elements[type].classList.remove('ulHideContent')
                    } else {
                        elements[type].classList.remove('ulShowContent')
                        elements[type].classList.add('ulHideContent')
                    }
                } else {
                    this.footerSideBarSwitch(type)
                }
            },
            boxFunc (type, event) {
                let e = event.currentTarget
                this.boxALLclass(e)
                this.jumpGuide(type)
                this.styleGuide(type)
                // 什么时候取消div的class
                this.liClassFunc(e)
            },
            mouseenterLiFunc (index) {
                this.isLiHoverEnter = index
            },
            mouseleaveLiFunc () {
                this.isLiHoverEnter = ' '
            }
        }
    }
</script>
<style scoped>
    li{
        list-style: none;
        cursor: pointer;
        position: relative;
    }
    h1{
        margin: 0;
    }
    ul{
        margin: 0;
        padding: 0;
    }
    .line_5 {
        display: inline-block;
        width: 3px;
        background-color: #333333;
        height: 31.5px;
        opacity: 0.3;
        /* border: 1.2px solid; */
        position: absolute;
        left: 0;
        top: 10px;
    }
    .borderSpanClass{
        opacity: 0.3;
        /* border: solid 1.2px #00e0da; */
        background-color: #00e0da;
    }
    .ulHideContent{
        opacity: 0;
        transition: all .7s;
        display: none;
    }
    .ulShowContent{
        opacity: 1;
        transition: all .7s;
        display: block;
    }
    .ulClass{
        /* background-color: rgba(0, 224, 218, 0.1); */
        border-radius: 14px;
        background-color: rgba(0, 224, 218, 0.5);
        padding-top: 2px;
    }
    .liClass{
        /* background-color: rgba(0, 224, 218, 0.1); */
        background-color: rgba(51, 51, 51, 0.1);
    }
    .developer_documataion_menu_overview {
        width: 212px;
        /* height: 34px; */
        font-family: sans-serif;
        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        color: #333333;
        padding: 18px 0px 18px 24px;
    }

    .developer_documataion_menu_overview:hover{
        padding-top: 14px;
    }
    .Rectangle {
        width: 260.2px;
        height: 62.2px;
        /* border-bottom: 3px solid #9ff2f0;  */
        cursor: pointer;
    }
    .Rectangle:hover {
        /* background-color: #cdf7f7; */
        border-radius: 14px;
        background-color: rgba(0, 224, 218, 0.1);
    }
    /* .displayMenu li:hover { */
        /* background-color: #cdf7f7; */
    /* } */
    /* .Rectangle {
        width: 259.8px;
        height: 62.2px;
        border-radius: 14px;
        background-color: rgba(255, 255, 255, 0);
        border-bottom: 3px solid #00e0da; 
    } */
    .boxMenu{
        float: right;
        margin-top: 148px;
    }
    .text {
        width: 236px;
        height: 34px;
        /* opacity: 0.8; */
        font-family: sans-serif;
        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        color: #333333;
        padding: 0px 0px 0px 24px; 
        margin-top: 8.8px; 
        margin-bottom: 5.4px;; 
        /* border-left: 2.6px solid #9ff2f0; */
        line-height: 34px;
        display: inline-block;
    }
/* [fu] */

    .treeview{
        transition: .7s;
    }
    .skin-blue .sidebar-menu > li.active > a{
        background: #e5fbfb;
    }
    /* .active{
        background: #e5fbfb;
    } */
    .activited{
        background: #cdf7f7!important;
    }
    /* override default */
    .sidebar-menu>li>a {
        padding: 12px 15px 12px 15px;
    }
    .sidebar-menu{
        margin-top:146px; 
    }
    .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
        animation-name: rotate;
        animation-duration: .2s;
        animation-fill-mode: forwards;
    }

    .treeview-title {
        z-index: 1;
    }


    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(-90deg);
        }
    }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?604dcd64